import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { Observable } from 'rxjs';
import { delay, retryWhen, take } from 'rxjs/operators';

export interface TrendText {
  author: string;
  id: number;
  text: string;
  writtenAt: string;
}

@Injectable({
  providedIn: 'root',
})
export class TrendService {
  private http = inject(HttpClient);

  private url = environment.url.bff;

  getTrendDataForAreaId(areaId): Observable<TrendText> {
    const urlForAreaId = this.url + '/trend/' + areaId;
    return this.http.get<TrendText>(urlForAreaId).pipe(
      // when error occurs, request gets repeated 5 times with a delay of 1000ms
      retryWhen(errors => errors.pipe(delay(1000), take(5)))
    );
  }
}
